import { BankAccountLocation } from '@40seas/entities/bank-account';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const FeeDefinitionCardOptionsSchema = z.object({
    location: EnumSchema(BankAccountLocation),
});

export class FeeDefinitionCardOptions extends FromSchema(FeeDefinitionCardOptionsSchema) {
    location: BankAccountLocation;
}
